<template>
  <div class="setting-main-container" v-if="getBusinessPermission || userType=='super_admin'">
    <div class="card setting-card">
      <div class="page-header d-flex justify-content-between">
        <h3 class="page-title">{{ $t('profile.documents.documents') }}</h3>
      </div>

      <table-component
        ref="documentData"
        :show-filter="false"
        :data="profileDocuments"
        table-class="table tax-table"
        class="mb-3"

      >
        <table-column
          :label="$t('profile.documents.document_type')"
          show="documentType.name"
        />
        <table-column
          :label="$t('profile.documents.document_name')"
          show="name"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t('customers.action') }} </span>
            <v-dropdown>
              <a slot="activator" href="#"><dot-icon /></a>
              <v-dropdown-item >
                <div class="dropdown-item" @click="documentNote(row)" >
                  <font-awesome-icon :icon="['fa', 'sticky-note']" class="dropdown-item-icon" />
                  {{ $t('general.note') }}
                </div>
              </v-dropdown-item>
              <v-dropdown-item>
                <div class="dropdown-item">
                  <a  :href="row.path"  target="_blank" v-if="row.path">
                    <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                    {{ $t('general.view') }}
                  </a>
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
const { required, maxLength, alpha,minLength,email } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      selectedCompany:null,
      userType:null,
    }
  },
  computed: {
    ...mapGetters('documentType', [
      'profileDocuments'
    ]),
    ...mapGetters('business', [
      'business' ,
      'getBusinessPermission',
    ]),

  },
  watch: {
  },
  validations: {
     formData: {}
  },
  created() {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    this.checkBusinessPermission();
    this.getProfileDocuments();
  },
   destroyed(){
      this.falseBusinessPermission()
  },
  mounted(){},
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('documentType', [
      'fetchProfileDocumentsByUser'
    ]),
    documentNote(data){
        this.openModal({
        'title': 'Document Note',
        'componentName': 'DocumentNoteModal',
        'id': data.id,
        'data': data
      })
    },
    getProfileDocuments(){
      let data = {
        user_id: this.$route.params.id
      }
      let res =  this.fetchProfileDocumentsByUser(data)
    },
    ...mapActions('business', [
      'BusinessPermission',
      'falseBusinessPermission'
    ]),
    checkBusinessPermission(){
        this.BusinessPermission(this.$route.params.id)
    }
  }
}
</script>
